import React from 'react'
import { useDesktopNotificationPermission } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { HorizontalStack, Icon, ShowIf } from '@ztechapps/webui.util'

// The bell menu's one row about desktop notifications. It shows the browser's
// `Notification.permission`; the permission is requested from the "Enable" click only.
export const NotificationDropdownDesktopAction = () => {
  const { permission, requestPermission } = useDesktopNotificationPermission()

  const handleEnable = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    await requestPermission()
  }

  if (permission === 'unsupported') return null

  return (
    <div className="px-3 py-2 border-bottom bg-body-tertiary">
      <ShowIf condition={permission === 'default'}>
        <HorizontalStack gap={2} className="align-items-start">
          <span className="text-body-secondary">
            <Icon name="bell" aria-hidden="true" />
          </span>
          <div>
            <small className="text-body-secondary">
              Get notified on your desktop while this tab is in the background.
            </small>
            <div className="text-nowrap fw-semibold">
              <BusyButtonLink onClick={handleEnable} text="Enable desktop notifications" />
            </div>
          </div>
        </HorizontalStack>
      </ShowIf>

      <ShowIf condition={permission === 'granted'}>
        <HorizontalStack gap={2} className="align-items-center">
          <span className="text-success-emphasis">
            <Icon name="check-circle" aria-hidden="true" />
          </span>
          <small>
            <span className="fw-semibold">Desktop notifications are on.</span>{' '}
            <span className="text-body-secondary">They show while this tab is in the background.</span>
          </small>
        </HorizontalStack>
      </ShowIf>

      <ShowIf condition={permission === 'denied'}>
        <HorizontalStack gap={2} className="align-items-start">
          <span className="text-warning-emphasis">
            <Icon name="ban" aria-hidden="true" />
          </span>
          <small>
            <span className="fw-semibold">Desktop notifications are blocked.</span>{' '}
            <span className="text-body-secondary">
              To unblock them, click the lock icon beside the address bar, set Notifications to Allow, then reload this
              page.
            </span>
          </small>
        </HorizontalStack>
      </ShowIf>
    </div>
  )
}
